import DOMPurify from 'dompurify';

export default {

    methods: {
        replaceVariables(rawText, fontClass, subPanelId, locale) {

            let text = DOMPurify.sanitize(rawText);

            if (typeof subPanelId === 'undefined') {
                throw new Error("SubPanelId is undefined!");
            }

            if (typeof locale === 'undefined') {
                throw new Error("Locale is undefined!");
            }

            if (!Number.isInteger(subPanelId)) {
                throw new Error("Sub Panel ID was expected to be integer");
            }

            const params = '/' + subPanelId + '/' + locale;

            text = this.replaceVariable('terms_policy_name', text, '/terms-of-use' + params, fontClass);
            text = this.replaceVariable('privacy_policy_name', text, '/privacy-policy' + params, fontClass);
            text = this.replaceVariable('cookie_policy_name', text, '/cookie-policy' + params, fontClass);
            text = this.replaceUnsubscribeLink('unsubscribe_link_text', text, fontClass);

            return text;
        },

        replaceVariable(variable, text, link, fontClass) {
            let regexp = new RegExp("\\[" + variable + ":([^:|\\]]+)]");
            let matches = text.match(regexp);

            if (matches) {
                let parts = [...matches];
                text = text.replace(
                    parts[0],
                    '<a href="' + link + '" class="' + fontClass + '" target="_blank">' + DOMPurify.sanitize(parts[1]) + '</a>'
                );
            }
            return text;
        },

        replaceUnsubscribeLink(variable, text, fontClass) {
            let regexp = new RegExp("\\[" + variable + ":([^:|\\]]+)]");
            let matches = text.match(regexp);

            if (matches) {
                let parts = [...matches];
                text = text.replace(
                    parts[0],
                    '<a href="#" class="' + fontClass + '">' + DOMPurify.sanitize(parts[1]) + '</a>'
                );
            }
            return text;
        }
    }
};

